import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { z } from 'zod';
import PermissionsService, { PERMISSION_EXPENSE_TYPE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import OperatingCostTypeDetail from '../../components/OperationCosts/OperatingCostsTypes/OperatingCostTypeDetail';
import OperatingCostTypeForm from '../../components/OperationCosts/OperatingCostsTypes/OperatingCostTypeForm';
import { URL_EXPENSE_TYPES } from '../../router/constants';

const editExpenseTypeSearchSchema = z.object({
  customerId: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_authenticated/expense_types/edit/$id')({
  validateSearch: editExpenseTypeSearchSchema,
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_EXPENSE_TYPE, ['read'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.detail',
        suffix: 'menu.expenseTypesOverview',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditExpenseTypeRoute,
});

function EditExpenseTypeRoute() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();
  const expenseTypeId = Number(id);
  const customerId = search.customerId ?? null;

  const handleClose = useCallback(() => {
    navigate({ to: URL_EXPENSE_TYPES });
  }, [navigate]);

  if (
    customerId !== null &&
    PermissionsService.hasAccess(PERMISSION_EXPENSE_TYPE, ['update'], customerId)
  ) {
    return (
      <OperatingCostTypeForm
        closeCallback={handleClose}
        selectedId={expenseTypeId}
        customerId={customerId}
      />
    );
  }

  return (
    <OperatingCostTypeDetail
      closeCallback={handleClose}
      id={expenseTypeId}
      customerId={customerId}
    />
  );
}
